export class MotivoCancelamento {
  id: number;
  descricao: string;
  pedidoId: number;
  dataCancelamento: Date;
  senhaCancelamento: string;
}
